module.exports = __webpack_public_path__ + "img/picture_zfbzxjc.f36cce51.png";